"use strict";

var BoldText = require("app/shared/components/BoldText/bold-text");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var CollapseText = require("app/shared/components/CollapseText/collapse-text");

function PlanCardFeatures(props) {
  return (
    <div className="mh-75">
        <ul className="planCard-features">
          <CollapseText height={125}>
            {FeaturesListItem(props.features)}
          </CollapseText>
        </ul>
    </div>
  );
};

PlanCardFeatures.propTypes = {
  features: React.PropTypes.arrayOf(
    React.PropTypes.shape({
      text: React.PropTypes.string.isRequired,
      externalInfo: React.PropTypes.string,
      tooltipText: React.PropTypes.string
    })
  ).isRequired
};

var FeaturesListItem = function FeaturesListItem(features) {
  return (
    features.map(function(feature, key) {
      if(feature.tooltipText) {
        return TolltipItem(key, feature.tooltipText, feature.text);
      } else if (feature.externalInfo){
        return LinkItem(key, feature.externalInfo, feature.text);
      }
      return Item(key, feature.text);
    })
  );
};

var TolltipItem = function TooltipItem(key, tooltipText, text){
  return (
    <li key={key} className="mt-10">
      <Tooltip title={tooltipText} container="body">
        <span className="bb-dotted c-help">
          <BoldText text={text} />
        </span>
      </Tooltip>
    </li>
  );
};

var LinkItem = function LinkItem(key, externalInfo, text){
  return (
    <li key={key} className="mt-10">
      <a href={externalInfo} className="cboxElement planCard-linkColor">
        <BoldText text={text} />
      </a>
    </li>
  );
};

var Item = function Item(key, text){
  return (
    <li key={key} className="mt-10">
      <BoldText text={text} />
    </li>
  );
};

module.exports = PlanCardFeatures;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-card-features.jsx